<template>
	<HeroLayout>
		<div class="flex flex-col h-full w-full">
			<img class="registration-title-image" :src="logoPath" alt="Logo" />
			<p v-if="!isLoading && !expired" class="registration-title">Hello, {{ userEmail }}!</p>

			<p v-if="isLoading" class="mb-10">Loading invite...</p>
			<div v-else class="mt-1 mb-10">
				<p v-if="!expired" class="registration-subtitle">You've been invited to join the {{ organizationName }} organization by {{ inviteeName }}!</p>
				<p v-else class="text-xl mt-4 text-error text-center">Your invitation has expired. Please contact your program administrator or use the <i>Contact us</i> link below.</p>
			</div>

			<form>
				<SubmitButton class="mx-auto" label="Accept Invite" :loading="isLoading" @click="acceptInvite" :disabled="expired" />
				<ValidationError :errors="error" :field="null" />
			</form>
		</div>
	</HeroLayout>
</template>

<script setup lang="js">

import { onMounted, ref } from 'vue'
import HeroLayout from '@/layouts/HeroLayout.vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import ValidationError from '@/components/Forms/InputError.vue'
import { useRoute } from 'vue-router'
import { userApi } from '@/api/User/UserApi.js'
import router from '@/router/router.js'
import { Tenants } from '@/models/tenants/Tenants.js'

const isLoading = ref(false)
const error = ref(null)
const userEmail = ref(null)
const inviteToken = ref(null)
const inviteeName = ref(null)
const organizationName = ref(null)
const expired = ref(false)
const logoPath = ref('')
const tenant = ref(null);

onMounted(() =>
{
	const query = useRoute().query
	inviteToken.value = query.token

	tenant.value = Tenants.getTenant()
	logoPath.value = new URL(`../../assets/images/theme/${tenant.value.registrationLogo.image}`, import.meta.url).href

	loadInvite()
})

function loadInvite()
{
	isLoading.value = true

	userApi.getInvite(inviteToken.value,
		(response) =>
		{
			//If the user has already created an account, redirect to login page.
			if (response.user_id && response.user_id > 0)
			{
				router.push({ name: 'auth.login' })
			}

			userEmail.value = response.email

			if (response.inviter_name_override && response.inviter_name_override.length > 0)
			{
				inviteeName.value = response.inviter_name_override
			}
			else
			{
				inviteeName.value = response.inviteeName
			}

			organizationName.value = response.organizationName

			expired.value = response.expired

			isLoading.value = false
		},
		(e) =>
		{
			expired.value = true;
			const details = e.errorDetails();
			if (details.length === 1 && details[0] !== 'Invalid token.')
			{
				e.showErrorBanner()
			}

			isLoading.value = false
		})
}

function acceptInvite()
{
	router.push({ name: 'auth.register', query: { token: inviteToken.value, email: userEmail.value } })
}

</script>
